import {FC, useState, createContext, useContext} from 'react'
import {WithChildren} from '../../../../../template/_metronic/helpers'
import {
  BatchCompleted,
  ListViewContextProps,
  initialListView,
} from '../../../../../interfaces/batch'

const ListViewContext = createContext<ListViewContextProps>(initialListView)

const ListViewProvider: FC<WithChildren> = ({children}) => {
  const [batchForUpdate, setBatchForUpdate] = useState<BatchCompleted | undefined>(
    initialListView.batchForUpdate
  )

  const [batchForCancel, setBatchForCancel] = useState<BatchCompleted | undefined>(
    initialListView.batchForCancel
  )

  return (
    <ListViewContext.Provider
      value={{
        batchForUpdate,
        setBatchForUpdate,
        batchForCancel,
        setBatchForCancel,
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

const useListView = () => useContext(ListViewContext)

export {ListViewProvider, useListView}
